<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
  let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <div class="form-check">
      <nb-icon class="icon" *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" icon="chevron-right-outline"
        [class.open]="!item.collapsed"></nb-icon>
      <label class="form-check-label" (click)="select(item, $event)">
        <input type="checkbox" class="form-check-input" [checked]="selected.includes(item.value)"
          [disabled]="item.disabled || (groupIds.includes(item.value) && disableGroupSelect)" />
        {{item.text}} ({{item.value}})
      </label>
      <a [routerLink]="'/' + ($clientId | async) + '/tags/' + item.value" class="tag-link"><nb-icon icon="external-link-outline"></nb-icon></a>
    </div>
  </div>
</ng-template>

<ngx-treeview [config]="config" [items]="items" [itemTemplate]="itemTemplate">
</ngx-treeview>
